import { render, staticRenderFns } from "./DocumentoFederal.vue?vue&type=template&id=9598a6de"
import script from "./DocumentoFederal.vue?vue&type=script&lang=js"
export * from "./DocumentoFederal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports